import {useMutation} from "@tanstack/react-query";
import {updateRetailLocation} from "../services/RetailLocationService";

export function useRetailLocationUpdate() {
    return useMutation({
        mutationFn: updateRetailLocation,
    });
}